// extracted by mini-css-extract-plugin
module.exports = {"container":"links-section_container__LP5jh","sectionTitle":"links-section_sectionTitle___j2D4"};